function validateHolidayDateFormat(value) {
  return /^\d{2}-\d{2}-\d{4}$/.test(value);
}

export function validatePricingHolidayPayload(payload) {
  if (!payload?.name?.trim()) {
    return "El nombre es obligatorio.";
  }

  const normalizedName = payload.name.trim();

  if (normalizedName.length < 10) {
    return "El nombre debe tener minimo 10 caracteres.";
  }

  if (normalizedName.length > 120) {
    return "El nombre no debe exceder 120 caracteres.";
  }

  if (!validateHolidayDateFormat(payload?.holidayDate || "")) {
    return "La fecha festiva debe respetar el formato dd-MM-yyyy.";
  }

  if (!Number.isFinite(Number(payload?.countryId)) || Number(payload.countryId) <= 0) {
    return "El pais es obligatorio.";
  }

  if (
    payload?.departmentId !== null &&
    payload?.departmentId !== undefined &&
    payload?.departmentId !== "" &&
    (!Number.isFinite(Number(payload.departmentId)) ||
      Number(payload.departmentId) <= 0)
  ) {
    return "El departamento no es valido.";
  }

  if (
    payload?.provinceId !== null &&
    payload?.provinceId !== undefined &&
    payload?.provinceId !== "" &&
    (!Number.isFinite(Number(payload.provinceId)) ||
      Number(payload.provinceId) <= 0)
  ) {
    return "La provincia no es valida.";
  }

  if (Number(payload?.multiplier) < 1) {
    return "El multiplicador debe ser como minimo 1.0.";
  }

  if (typeof payload?.active !== "boolean") {
    return "El estado activo es obligatorio.";
  }

  return null;
}
